import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from "@angular/material";
import { Router } from "@angular/router";
import { arLocale } from "ngx-bootstrap";
import { ToastrService } from "ngx-toastr";
import { AppConfig } from "src/app/app.config";
import { ConfirmDialogComponent, ConfirmDialogModel } from "src/app/shared/components/confirm-dialog/confirm-dialog.component";
import { EmployeeService } from "src/app/shared/service/employee.service";
import { MonthClosureService } from "src/app/shared/service/month-closure.service";
import { UserService } from "src/app/shared/service/user.service";
import { isNullOrUndefined } from "util";

@Component({
  selector: "app-hr-otherearnings-details",
  templateUrl: "./hr-otherearnings-details.component.html",
  styleUrls: ["./hr-otherearnings-details.component.css"],
})
export class HROtherEarningsDetailsComponent implements OnInit {
  otherearningDataSource: MatTableDataSource<any>;
  otherearningdisplayedColumns: string[] = [
    "NamePerRecords",
    "LocationName",
    "Department",
    "CadreName",
    "EarningPurpose",
    "EarningAmount",
    "remove",
  ];
  error: string;
  isFreeze = true;
  employeeDetails: any;
  employeeList: any;
  vendorList = [];
  currentMonth = "";
  currentFY = "";
  otherFrom: any;
  @ViewChild("otherearningpaginatorAll", { static: true })
  otherearningpaginatorAll: MatPaginator;
  @ViewChild("otherearningsortAll", { static: true })
  otherearningsortAll: MatSort;
  iisVisible: boolean = false;
  constructor(
    private _service: MonthClosureService,
    private config: AppConfig,
    public router: Router,
    private toastr: ToastrService,
    public _userService: UserService,
    private otherFormBuilder: FormBuilder,
    private dialog: MatDialog,
    
    
  ) {
    this.otherFrom = this.otherFormBuilder.group({
      otherDetails: this.otherFormBuilder.array([],this.duplicateRowValidator),
    });
    this.otherearningDataSource = new MatTableDataSource();
  }
  ngOnInit() {}
  create() {
    var row = {
      NamePerRecords: "",
      LocationName: "",
      Department: "",
      CadreName: "",
      EarningPurpose: "",
      EarningAmount: "",
      remove: "",
    };
    return row;
  }
  employeeSelectd(event, row) {
    row.EmpCode = event.option.id;
    var emp = this.employeeDetails.filter(
      (c) => c.EmpCode == event.option.id
    )[0];
    row.LocationName = emp.LocationName;
    row.Department = emp.Department;
    row.CadreName = emp.CadreName;
    row.FY = this.currentFY;
    row.Month = this.currentMonth;

    row.NamePerRecords = `${emp.EmpCode} - ${emp.NamePerRecords}`;
  }
  doFilterOnEmployee(element) {
    if (element.NamePerRecords != "") {
      this.employeeList = this.filterEmployee(
        this.employeeDetails,
        element.NamePerRecords
      );
      //element.id = 0;
    }
  }

  filterEmployee(values, NamePerRecords) {
    return values.filter((value) =>
      value.NamePerRecords && value.NamePerRecords !== ""
        ? value.NamePerRecords.toLowerCase().includes(NamePerRecords.toLowerCase()) ||
        value.EmpCode.toString().includes(NamePerRecords)
        : false
    );
  }
  duplicateRowValidator = (formArray: any): { [key: string]: any } | null => {
    const rows = (formArray as FormArray).controls;
    let values = rows.map(row => row.get('NamePerRecords')!=null ?row.get('NamePerRecords').value+"-"+row.get('EarningPurpose').value:null);
    // if(!!values)
    //   {
    //     values=values.filter(c=>c.IsActive!=true)
    //   }
    if(!!values)
    {
    const duplicates = values.filter((value, index) => values.indexOf(value) !== index);

    rows.forEach(row => {
      const valueControl = row.get('NamePerRecords');
      const valuePurposeControl = row.get('EarningPurpose');
      if (valueControl && valueControl.value!=""&&  duplicates.length>0) {
        debugger;
        valueControl.setErrors(duplicates[0].includes(valueControl.value) && duplicates[0].includes(valuePurposeControl.value) ? { duplicate: true } : null);
        valuePurposeControl.setErrors(duplicates[0].includes(valueControl.value) && duplicates[0].includes(valuePurposeControl.value) ? { duplicate: true } : null);
      }
      else{
        valueControl.setErrors(null);
        if (valueControl && valueControl.value=="")
        valueControl.setErrors({ required: true });
        valuePurposeControl.setErrors(null);
        if (valuePurposeControl && valuePurposeControl.value=="")
          valuePurposeControl.setErrors({ required: true });
        //valueControl.setErrors(null)
        //valuePurposeControl.setErrors(null)
      }
    });

    return duplicates.length > 0 ? { duplicate: true } : null;
  }
  return null;
  };
  removeAt($event:any,index: number, row: any) {
    const message = "Are you sure you want to delete this record?";
    const dialogData = new ConfirmDialogModel("Confirm Delete", message, "Submit", "OK", "Cancel");
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "500px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
    $event.preventDefault(); 
    const data = this.otherearningDataSource.data;
    if (!!row && row.OtherEarningId > 0) 
      {
        row.IsActive = true;
        var result = this.otherearningDataSource.data.filter(s => s.IsActive==true );
        if (result != null && result.length > 0) {
          result[0].LoginUserName = this._userService.getEmail();
          result[0].IsFreezed = this.isFreeze;
          this._service.saveOtherEarningsDetails(result).subscribe(
            (data: any[]) => {
              this.toastr.success("Deleted Successfully");
              const items = this.otherFrom.get("otherDetails")as FormArray;
              // Remove the control at the specified index
               items.removeAt(index);
               this.otherearningDataSource.data = this.otherearningDataSource.data.filter(s => s.IsActive!=true );
            },
            (error) => (this.error = error)
          );
        }
      }
    else
    {
      data.splice(
          index,
        1
      );
      const items = this.otherFrom.get("otherDetails")as FormArray;
      // Remove the control at the specified index
       items.removeAt(index);
      this.otherearningDataSource.data = data.filter(s => s.IsActive!=true );
     
     // this.getOtherEarningDetails();
    }

    // this.otherearningDataSource.data = data.filter(s => s.IsActive!=true );
    // let validationArray = this.otherFormBuilder.array([],this.duplicateRowValidator);

    // this.otherearningDataSource.data.forEach((detail) => {
    //   validationArray.push(this.createOtherFormGroup(detail));
    // });
    // this.otherFrom.setControl("otherDetails", validationArray);
  }
});
  }

  addRow() {
    this.otherearningDataSource.data.push(this.create());
    this.otherearningDataSource.filter = "";
    let validationArray = this.otherFormBuilder.array([],this.duplicateRowValidator);

    this.otherearningDataSource.data.forEach((detail) => {
      validationArray.push(this.createOtherFormGroup(detail));
    });
    this.otherFrom.setControl("otherDetails", validationArray);
  }
  getOtherEarningDetails() {
    this.otherearningDataSource.data = [];
    this._service.getOtherEarningDetails(this.currentMonth).subscribe(
      (data: any[]) => {

        if (data != null && data.length > 0) {
          let validationArray = this.otherFormBuilder.array([],this.duplicateRowValidator);
          for (var i = 0; i < data.length; i++) {
            var emp = this.employeeDetails.filter(
              (c) => c.EmpCode == data[i].EmpCode
            )[0];
            data[i].LocationName = data[i].Location;
            data[i].Department = data[i].Department;
            data[i].CadreName = data[i].Cadre;
            if(!!emp)
            data[i].NamePerRecords = `${emp.EmpCode} - ${emp.NamePerRecords}`;
            validationArray.push(this.createOtherFormGroup(data[i]));
          }
          this.otherFrom.setControl("otherDetails", validationArray);
          if (this.isFreeze == false) {
            this.isFreeze = data[0].IsFreezed;
          }
        }
        this.otherearningDataSource.data = data;
   
      },
      (error) => (this.error = error)
    );
  }
  changed(row) {
    row.IsUpdated = true;
  }
  saveOtherEarningsDetails() {

    if (this.otherFrom.invalid) {
      this.toastr.warning("Please fill in the required fields");
      this.otherFrom.markAllAsTouched();
      return;
    }
    var result = this.otherearningDataSource.data.filter(s =>s.IsFromJoiners!=true&&( s.IsActive==false ||s.IsActive==null || s.IsActive==undefined) );; //.filter(s => s.IsUpdated==true);
  
    if (result != null && result.length > 0) {
      result[0].IsFreezed = this.isFreeze;
      result[0].LoginUserName = this._userService.getEmail();
      this._service.saveOtherEarningsDetails(result).subscribe(
        (data: any[]) => {
          this.toastr.success("Saved Successfully");
          this.getOtherEarningDetails();
        },
        (error) => (this.error = error)
      );
    }
    else{
      this.toastr.warning("No records are updated");
    }
  }
  private createOtherFormGroup(item: any): FormGroup {
    return new FormGroup({
      EarningPurpose: new FormControl({value:item.EarningPurpose,disabled: this.isFreeze}, [
        Validators.required,
      ]),
      NamePerRecords: new FormControl({value:item.NamePerRecords,disabled: this.isFreeze==false?item.IsFromJoiners:this.isFreeze}, [
        Validators.required,
      ]),
      EarningAmount: new FormControl({value:item.EarningAmount,disabled: this.isFreeze==false?item.IsFromJoiners:this.isFreeze}, [
        Validators.required,Validators.pattern("(?!0$)\\d{1,9}?$"),
      ]),
    });
  }
}
